//#region src/core/i18n/locales/da.ts
var da_default = {
	buttons: {
		play: "Afspil",
		pause: "Pause",
		replay: "Afspil igen",
		mute: "Uden lyd",
		unmute: "Med lyd"
	},
	seek: {
		forward: "Spring {seconds} sekunder frem",
		backward: "Spring {seconds} sekunder tilbage"
	},
	fullscreen: {
		enter: "Fuldskærm",
		exit: "Luk fuldskærm"
	},
	captions: {
		enable: "Aktivér undertekster",
		disable: "Deaktiver undertekster"
	},
	pip: {
		enter: "Billede-i-billede",
		exit: "Afslut billede-i-billede"
	},
	live: {
		playing: "Afspiller live",
		seekToEdge: "Gå til live",
		badge: "Live"
	},
	cast: {
		start: "Start afsendelse",
		stop: "Stop afsendelse",
		connecting: "Forbinder"
	},
	airplay: {
		start: "Start AirPlay",
		stop: "Stop AirPlay"
	},
	slider: { seek: "Spol" },
	time: {
		current: "Aktuel tid",
		duration: "Varighed",
		remaining: "Resterende tid",
		elapsedSuffix: "{duration} forløbet tid",
		durationSuffix: "{duration} varighed",
		remainingSuffix: "{duration} tilbage",
		showElapsed: "Vis forløbet tid, {duration}.",
		showDuration: "Vis varighed, {duration}.",
		showRemaining: "Vis resterende tid, {duration}.",
		toggleElapsed: "Skift mellem forløbet og resterende tid.",
		toggleDuration: "Skift mellem varighed og resterende tid.",
		position: "{current} af {duration}",
		unknown: "Mediet er ikke indlæst, tidspunktet er ukendt."
	},
	playback: { rate: "Afspilningsrate {rate}" },
	volume: {
		mutedValue: "{percent}, lydløs",
		muted: "Lydløs",
		label: "Lydstyrke",
		value: "Lydstyrke {value}"
	},
	status: {
		captionsOn: "Undertekster til",
		captionsOff: "Undertekster fra",
		paused: "Pauseret",
		playing: "Afspiller",
		fullscreen: "Fuldskærm",
		pip: "Billede i billede",
		exitPip: "Afslut billede i billede",
		seekedTo: "Sprunget til {time}"
	},
	container: { label: "Medieafspiller" },
	errors: {
		aborted: "Du afbrød videoafspilningen.",
		network: "En netværksfejl fik download af videoen til at fejle.",
		decode: "Videoafspilningen blev afbrudt på grund af ødelagte data eller fordi videoen benyttede faciliteter som din browser ikke understøtter.",
		source: "Videoen kunne ikke indlæses, enten fordi serveren eller netværket fejlede, eller fordi formatet ikke er understøttet.",
		encrypted: "Mediet er krypteret, og der er ingen nøgler til at dekryptere det.",
		unplayable: "Denne mediefil understøttes ikke af afspilleren.",
		title: "Noget gik galt.",
		unexpected: "Der opstod en fejl. Prøv igen."
	},
	common: {
		empty: "",
		ok: "OK"
	},
	menu: {
		settings: "Indstillinger",
		quality: "Kvalitet",
		audio: "Lyd",
		default: "Standard",
		speed: "Hastighed",
		captions: "Undertekster",
		playbackRate: "Afspilningshastighed",
		back: "Tilbage",
		off: "Fra",
		auto: "Auto",
		autoWithLabel: "Auto ({label})",
		subtitles: "Undertekster"
	}
};
//#endregion
export { da_default as default };

//# sourceMappingURL=da.js.map